// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedbackForm_form_wrap__wASzW {
  width: 100%;
  max-width: 1180px;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_top_part__aSv52 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_top_part__aSv52 div {
  width: calc(33% - 10px);
  height: 50px;
  position: relative;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_top_part__aSv52 div button {
  position: absolute;
  top: 50%;
  transform: translateY(-53%);
  right: 5px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 30px;
  padding: 0;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_top_part__aSv52 input {
  width: 100%;
  height: 100%;
  padding: 13px 18px;
  padding-right: 25px;
  border: none;
  outline: none;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_message__4qF3a {
  width: 100%;
  min-height: 150px;
  margin-bottom: 60px;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_message__4qF3a textarea {
  width: 100%;
  height: 100%;
  min-height: 150px;
  padding: 13px 18px;
  border: none;
  outline: none;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_form_input_error__F5Q5t {
  border: 1px solid red;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_form_input_error__F5Q5t input::placeholder {
  color: red;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_form_input_error__F5Q5t span {
  color: red;
  font-size: 12px;
  line-height: 1;
}
.feedbackForm_form_wrap__wASzW .feedbackForm_buttom_wrap__ZrwlY {
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
}
.feedbackForm_form_wrap__wASzW p {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 45px;
  text-align: center;
  text-transform: uppercase;
  color: var(--primary-color);
  margin-bottom: 50px;
}
@media (max-width: 991px) {
  .feedbackForm_form_wrap__wASzW {
    max-width: 90%;
    font-size: 16px;
  }
  .feedbackForm_form_wrap__wASzW .feedbackForm_top_part__aSv52 div {
    height: 40px;
  }
  .feedbackForm_form_wrap__wASzW .feedbackForm_top_part__aSv52 input {
    padding: 10px;
    padding-right: 20px;
  }
  .feedbackForm_form_wrap__wASzW .feedbackForm_message__4qF3a {
    margin-bottom: 40px;
    min-height: 100px;
  }
  .feedbackForm_form_wrap__wASzW .feedbackForm_message__4qF3a textarea {
    min-height: 100px;
    padding: 10px;
  }
  .feedbackForm_form_wrap__wASzW .feedbackForm_buttom_wrap__ZrwlY {
    margin-bottom: 20px;
  }
  .feedbackForm_form_wrap__wASzW p {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 30px;
  }
}

.feedbackForm_form_button__9BXu\\+ {
  min-width: 270px;
  border-radius: 12px;
  padding: 15px 0;
  background-color: var(--secondary-color);
  border: 2px solid var(--secondary-color);
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
  cursor: pointer;
}
@media (max-width: 991px) {
  .feedbackForm_form_button__9BXu\\+ {
    padding: 10px 24px;
    min-width: fit-content;
  }
}

.feedbackForm_disabled__2V249 {
  background-color: #d3d3d3;
  border: 2px solid #d3d3d3;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/FeedbackForm/feedbackForm.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;AACN;AAAM;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAER;AAEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAAN;AAIE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAFN;AAME;EACE,qBAAA;AAJJ;AAMI;EACE,UAAA;AAJN;AAOI;EACE,UAAA;EACA,eAAA;EACA,cAAA;AALN;AASE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,mBAAA;AARJ;AAWE;EAzFF;IA0FI,cAAA;IACA,eAAA;EARF;EAWI;IACE,YAAA;EATN;EAWI;IACE,aAAA;IACA,mBAAA;EATN;EAaE;IACE,mBAAA;IACA,iBAAA;EAXJ;EAaI;IACE,iBAAA;IACA,aAAA;EAXN;EAeE;IACE,mBAAA;EAbJ;EAgBE;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EAdJ;AACF;;AAkBA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAfF;AAiBE;EAbF;IAcI,kBAAA;IACA,sBAAA;EAdF;AACF;;AAiBA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;AAdF","sourcesContent":[".form_wrap {\n  width: 100%;\n  max-width: 1180px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .top_part {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n\n    div {\n      width: calc(33% - 10px);\n      height: 50px;\n      position: relative;\n      button {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-53%);\n        right: 5px;\n        border: none;\n        background: none;\n        cursor: pointer;\n        font-size: 30px;\n        padding: 0;\n      }\n    }\n\n    input {\n      width: 100%;\n      height: 100%;\n      padding: 13px 18px;\n      padding-right: 25px;\n      border: none;\n      outline: none;\n    }\n  }\n\n  .message {\n    width: 100%;\n    min-height: 150px;\n    margin-bottom: 60px;\n\n    textarea {\n      width: 100%;\n      height: 100%;\n      min-height: 150px;\n      padding: 13px 18px;\n      border: none;\n      outline: none;\n    }\n  }\n\n  .form_input_error {\n    border: 1px solid red;\n\n    input::placeholder {\n      color: red;\n    }\n\n    span {\n      color: red;\n      font-size: 12px;\n      line-height: 1;\n    }\n  }\n\n  .buttom_wrap {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 50px;\n  }\n\n  p {\n    text-align: center;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 45px;\n    text-align: center;\n    text-transform: uppercase;\n    color: var(--primary-color);\n    margin-bottom: 50px;\n  }\n\n  @media (max-width: 991px) {\n    max-width: 90%;\n    font-size: 16px;\n\n    .top_part {\n      div {\n        height: 40px;\n      }\n      input {\n        padding: 10px;\n        padding-right: 20px;\n      }\n    }\n\n    .message {\n      margin-bottom: 40px;\n      min-height: 100px;\n\n      textarea {\n        min-height: 100px;\n        padding: 10px;\n      }\n    }\n\n    .buttom_wrap {\n      margin-bottom: 20px;\n    }\n\n    p {\n      font-size: 16px;\n      line-height: 20px;\n      margin-bottom: 30px;\n    }\n  }\n}\n\n.form_button {\n  min-width: 270px;\n  border-radius: 12px;\n  padding: 15px 0;\n  background-color: var(--secondary-color);\n  border: 2px solid var(--secondary-color);\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: #ffffff;\n  cursor: pointer;\n\n  @media (max-width: 991px) {\n    padding: 10px 24px;\n    min-width: fit-content;\n  }\n}\n\n.disabled {\n  background-color: #d3d3d3;\n  border: 2px solid #d3d3d3;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_wrap": `feedbackForm_form_wrap__wASzW`,
	"top_part": `feedbackForm_top_part__aSv52`,
	"message": `feedbackForm_message__4qF3a`,
	"form_input_error": `feedbackForm_form_input_error__F5Q5t`,
	"buttom_wrap": `feedbackForm_buttom_wrap__ZrwlY`,
	"form_button": `feedbackForm_form_button__9BXu+`,
	"disabled": `feedbackForm_disabled__2V249`
};
export default ___CSS_LOADER_EXPORT___;
